import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Row, Col } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import logo from '../assets/logo.png';
import './LoginPage.css';

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await authService.login(values.email, values.password);
      navigate('/');
      window.location.reload(); // To refresh and update auth state in App.js
    } catch (error) {
      message.error(error.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <div className="promotional-block">
        <img src={logo} alt="Keshav HRMS Logo" className="app-logo" />
        <h1>Welcome to Keshav HRMS</h1>
        <p>Your all-in-one solution for managing human resources efficiently. Access payslips, manage attendance, and more with our mobile app.</p>
        <div className="store-buttons">
          <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer">
            <img src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" alt="Get it on Google Play" />
          </a>
          <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
            <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store" />
          </a>
        </div>
      </div>
      <div className="login-form-container">
        <Card className="login-card" style={{ width: 400, textAlign: 'center' }}>
          <h2 style={{ marginBottom: '20px' }}>Admin Login</h2>
          <Form
            name="login"
            onFinish={onFinish}
            layout="vertical"
          >
            <Form.Item
              name="email"
              label="E-mail"
              rules={[
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!',
                },
                {
                  required: true,
                  message: 'Please input your E-mail!',
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="password"
              label="Password"
              rules={[
                {
                  required: true,
                  message: 'Please input your password!',
                },
              ]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%' }}>
                Login
              </Button>
            </Form.Item>
            <Row justify="space-between">
              <Col>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </Col>
              <Col>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </Col>
            </Row>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default LoginPage; 